import React from 'react';
import ReactDOM from 'react-dom/client';
import '@renderer/shared/tokens/theme.css';
import '@renderer/shared/tokens/app.css';
import { App } from './app/App';
import { installBrowserDevBridgeIfNeeded } from './lib/browser-dev-bridge';
import { isWebConsoleMode } from './lib/web-console-api';

async function renderApp(): Promise<void> {
  if (!isWebConsoleMode()) {
    await installBrowserDevBridgeIfNeeded();
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void renderApp();
